import DisputesContainer from "./DisputesContainer";

export default DisputesContainer;
